import { Chip, styled } from '@zeiss/beyond-online-react';
import { StyledContainer } from '@zeiss/lib-components';
import { useBreakpoint } from '@zeiss/lib-helpers';

import { ApplicationResponse } from 'src/types/rest/tenant';

interface ChipContainerProps extends StyledContainer {
  $disabled: boolean;
}
const ChipContainer = styled.div<ChipContainerProps>`
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-responsive-s, 16px) var(--spacing-s, 16px);
  align-content: flex-start;
  align-items: flex-start;
  align-self: stretch;

  ${({ $isMinDesktopL }) =>
    /* istanbul ignore next -- @preserve */
    $isMinDesktopL
      ? // Headline size is 28px.
        `margin-top: calc(var(--spacing-xs) + 28px);`
      : `margin-top: var(--spacing-m);`}

  ${({ $disabled }) => !$disabled && `margin-top: var(--spacing-m);`}
`;

type ManagingApplicationResultsProps = {
  managingApplications: ApplicationResponse[];
} & (
  | {
      disabled: false;
      onDeselect: (id: ApplicationResponse['id']) => void;
    }
  | {
      disabled: true;
      onDeselect?: (id: ApplicationResponse['id']) => void;
    }
);

export const ManagingApplicationsResult = ({
  disabled,
  managingApplications,
  onDeselect,
}: ManagingApplicationResultsProps) => {
  const isMinDesktopL = useBreakpoint('desktopL');

  return (
    <ChipContainer $disabled={disabled} $isMinDesktopL={isMinDesktopL}>
      {managingApplications.map((application) => (
        <Chip
          color="warning"
          fill="strong"
          key={application.id}
          label={application.name}
          onClose={disabled ? undefined : () => onDeselect(application.id)}
          shape="rectangular"
          size="xs"
        />
      ))}
    </ChipContainer>
  );
};
